import * as React from 'react';
export const IcMoonrise = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15 18H9c-.27 0-.52.11-.71.29A.99.99 0 008 19c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0015 18zm3-4h-2.17a6.943 6.943 0 002.07-3.69c.56-2.86-.7-5.63-2.95-7.15-.74-.5-1.66.21-1.49 1.08.18.93.14 1.93-.17 2.92-.73 2.36-2.94 4.07-5.41 4.19-.59.03-1.15-.03-1.68-.15-.88-.21-1.51.82-1.02 1.58.29.44.63.85 1.01 1.21h-.18c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1L18 14z'
      fill='currentColor'
    />
  </svg>
);
